import React, {
  useMemo,
  useEffect,
  useCallback,
  useState
} from 'react';
import { Column, ColumnFixing, HeaderFilter } from 'devextreme-react/data-grid';
import {
  Template,
  Button,
  SelectBox,
  TextBox
} from 'devextreme-react';
import { CheckBox } from 'devextreme-react/check-box';
import TextArea from 'devextreme-react/text-area';
import {
  Validator,
  EmailRule,
  PatternRule,
  RequiredRule,
  StringLengthRule
} from 'devextreme-react/validator';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import SplitterLayout from 'react-splitter-layout';
import 'react-splitter-layout/lib/index.css';

import { formatMessage } from 'devextreme/localization';
import DataGridMVP from '../../DataGridMVP';
import PopupMVP from '../../PopupMVP';

import style from './useradmin.module.scss';
import columnDataGrid from './columnDataGrid';
import columnDataGridUser from './columnDataGridUser';
import columnDataGridRole from './columnDataGridRole';

const initDataUser = {
  title: null,
  userId: null,
  userName: null,
  name: null,
  phoneNumber: null,
  deletedFlag: 'N',
  isVendorUser: 'Y',
  emailAddress: null,
  requestId: null,
  notes: null
};

const UserAdmin = ({
  selectedIndex,
  userReducer: {
    id
  },
  adminReducer: {
    loadingUser,
    listUsers,
    listRoles,
    loadingRole,
    listRolesOnUser,
    dataAddRole,
    dataDelRole,
    dataAddOrEditUser,
    loadingVisits,
    listVisits
  },
  getUsersList,
  getRolesOnUser,
  getRolesList,
  addRoleOnUser,
  addRoleOnUserClear,
  deleteRoleOnUser,
  deleteRoleOnUserClear,
  createOrUpdateUser,
  createOrUpdateUserClear,
  getVisitsUser,
  getVisitsUserClear
}) => {
  const [selectedRowsDataUser, setSelectedRowsDataUser] = useState([]);
  const [visibleModalAddRole, setVisibleModalAddRole] = useState(false);
  const [visibleModalDelRole, setVisibleModalDelRole] = useState(false);
  const [visibleModalAddOrEditUser, setVisibleModalAddOrEditUser] = useState(false);
  const [visibleModalVisitsUser, setVisibleModalVisitsUser] = useState(false);
  const [selectRoleAddUser, setSelectRoleAddUser] = useState(null);
  const [selectRoleDelUser, setSelectRoleDelUser] = useState(null);
  const [dataUser, setDataUser] = useState(initDataUser);
  const [thisDataGridInstance, setThisDataGridInstance] = useState({});
  const [isForeignNumber, setIsForeignNumber] = useState(false);
  /** Фильтры по таблице */
  const [filterVisitDataGrid, setFilterVisitDataGrid] = useState({
    dateFrom: '',
    dateTo: '',
    filter: '',
    userId: id
  });
  useEffect(() => {
    if (selectedIndex === 0) {
      getUsersList();
      getRolesList();
    }
  }, [
    getUsersList,
    selectedIndex,
    getRolesList
  ]);
  useEffect(() => {
    if (visibleModalVisitsUser) {
      getVisitsUser(filterVisitDataGrid);
    }
  }, [filterVisitDataGrid, getVisitsUser, visibleModalVisitsUser]);
  useEffect(() => {
    if (
      visibleModalAddRole
      && dataAddRole.okRequest
    ) {
      setVisibleModalAddRole(false);
      addRoleOnUserClear();
    }
  }, [
    addRoleOnUserClear,
    visibleModalAddRole,
    dataAddRole.okRequest
  ]);
  useEffect(() => {
    if (
      visibleModalDelRole
      && dataDelRole.okRequest
    ) {
      setVisibleModalDelRole(false);
      deleteRoleOnUserClear();
    }
  }, [
    deleteRoleOnUserClear,
    visibleModalDelRole,
    dataDelRole.okRequest
  ]);
  useEffect(() => {
    if (
      visibleModalAddOrEditUser
      && dataAddOrEditUser.okRequest
    ) {
      setVisibleModalAddOrEditUser(false);
      if (dataAddOrEditUser.data && thisDataGridInstance.instance) {
        // перейти к строчке пользователя
        const temp = dataAddOrEditUser.data;
        thisDataGridInstance.instance.clearSelection();
        setTimeout(() => {
          thisDataGridInstance.instance.selectRows([temp], false);
          thisDataGridInstance.instance.navigateToRow(temp);
        }, 500);
      }
      createOrUpdateUserClear();
    }
  }, [
    createOrUpdateUserClear,
    visibleModalAddOrEditUser,
    dataAddOrEditUser.okRequest,
    dataAddOrEditUser.data,
    thisDataGridInstance
  ]);

  useEffect(() => {
    setIsForeignNumber(Boolean(dataUser.phoneNumber) && dataUser.phoneNumber.length !== 10);
  }, [dataUser]);

  const onHidingModalVisitsUser = useCallback(() => {
    setVisibleModalVisitsUser(false);
    getVisitsUserClear();
  }, [getVisitsUserClear]);
  const onHidingModalAddOrEditUser = useCallback(() => {
    setVisibleModalAddOrEditUser(false);
  }, []);
  const openModalAddOrEditUser = useCallback((data = initDataUser) => {
    let tempPhone = data.phoneNumber;
    if (data.phoneNumber && data.phoneNumber[0] === '7') {
      tempPhone = data.phoneNumber.slice(1);
    }
    setDataUser({
      ...data,
      title: data.userId ? 'Редактирование пользователя' : 'Добавить пользователя',
      phoneNumber: tempPhone
    });
    setVisibleModalAddOrEditUser(true);
  }, [
    setDataUser
  ]);
  const sendSaveAddOrEditUser = useCallback(() => {
    createOrUpdateUser({
      ...dataUser,
      phoneNumber: isForeignNumber ? dataUser.phoneNumber.replace(/\D+/g, '') : `${dataUser.phoneNumber.slice(0, 10)}`
    });
  }, [createOrUpdateUser, dataUser, isForeignNumber]);

  const openModalAddRole = useCallback(() => {
    setVisibleModalAddRole(true);
    setSelectRoleAddUser(null);
  }, []);
  const onHidingModalAddRole = useCallback(() => {
    setVisibleModalAddRole(false);
  }, []);
  const sendSaveAddRole = useCallback(() => {
    addRoleOnUser({
      roleId: selectRoleAddUser.roleId,
      userId: selectedRowsDataUser[0].userId
    });
  }, [
    selectRoleAddUser,
    addRoleOnUser,
    selectedRowsDataUser
  ]);

  const openModalDelRole = useCallback((data) => {
    setSelectRoleDelUser(data.data);
    setVisibleModalDelRole(true);
  }, [
    setSelectRoleDelUser
  ]);
  const onHidingModalDelRole = useCallback(() => {
    setVisibleModalDelRole(false);
  }, []);
  const sendSaveDelRole = useCallback(() => {
    deleteRoleOnUser({
      roleId: selectRoleDelUser.roleId,
      userId: selectedRowsDataUser[0].userId
    });
  }, [
    deleteRoleOnUser,
    selectRoleDelUser,
    selectedRowsDataUser
  ]);

  const toolbarButtonAddUser = useMemo(() => () => (
    <Button type="default"
            stylingMode="contained"
            icon="plus"
            text="Добавить"
            elementAttr={{ class: style.buttonAdd }}
            onClick={() => openModalAddOrEditUser()}
    />
  ), [openModalAddOrEditUser]);
  const toolbarButtonVisitUser = useMemo(() => () => (
    <Button type="default"
            stylingMode="contained"
            text="Визиты"
            elementAttr={{ class: style.buttonAdd }}
            onClick={() => setVisibleModalVisitsUser(true)}
    />
  ), [setVisibleModalVisitsUser]);
  const toolbarButtonAddRole = useMemo(() => () => (
    <Button type="default"
            stylingMode="contained"
            icon="plus"
            text="Добавить"
            elementAttr={{ class: style.buttonAdd }}
            disabled={!selectedRowsDataUser.length}
            onClick={openModalAddRole}
    />
  ), [selectedRowsDataUser, openModalAddRole]);

  const onSelectUser = useCallback(({ selectedRowsData }) => {
    setSelectedRowsDataUser(selectedRowsData);
    if (selectedRowsData && selectedRowsData.length) {
      setFilterVisitDataGrid({
        ...filterVisitDataGrid,
        userId: selectedRowsData[0].userId
      });
      getRolesOnUser({ userId: selectedRowsData[0].userId });
    }
  }, [filterVisitDataGrid, getRolesOnUser]);

  const renderButtonDelRole = useMemo(() => (data) => (
    <Button type="default"
            stylingMode="text"
            icon="trash"
            onClick={() => openModalDelRole(data)}
    />
  ), [openModalDelRole]);
  const renderButtonEditUser = useMemo(() => (data) => (
    <Button type="default"
            stylingMode="text"
            icon="edit"
            /* eslint-disable-next-line react/destructuring-assignment */
            onClick={() => openModalAddOrEditUser(data.data)}
    />
  ), [openModalAddOrEditUser]);

  /** Поисковая строка */
  const dataGridOnOptionChanged = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      setFilterVisitDataGrid({
        ...filterVisitDataGrid,
        filter: value
      });
    }
  }, [filterVisitDataGrid]);

  const cellRenderDeletedFlag = useMemo(() => (data) => {
    // eslint-disable-next-line react/destructuring-assignment
    if (data.value === 'Y') {
      return <CheckBox defaultValue />;
    }
    return <CheckBox defaultValue={false} />;
  }, []);

  const renderColumnDataGridUser = useMemo(
    () =>
      columnDataGridUser.map((item) => (
        <Column
          dataField={item.dataField}
          key={item.dataField}
          caption={item.caption}
          visible
          allowFiltering
          width={item.width}
          cellRender={item.cellRender && cellRenderDeletedFlag}
          dataType={item.dataType}
          allowSearch={!item.notAllowSearch}
          sortOrder={item.sortOrder}
        >
          {item.headerFilter
            && (
            <HeaderFilter dataSource={[
              {
                text: 'Да',
                value: [item.dataField, '=', 'Y']
              },
              {
                text: 'Нет',
                value: [item.dataField, '=', 'N']
              }
            ]}
            />
            )}
        </Column>
      )),
    [cellRenderDeletedFlag]
  );

  const renderUserList = useMemo(() => (
    <DataGridMVP className="shipment"
                 setStateStoringName="dataGridUserList"
                 keyExpr="userId"
                 setDataGridInstance={setThisDataGridInstance}
                 visibleButtonDateRangePicker={false}
                 visibleSummary={false}
                 visibleGroupPanel={false}
                 visibleInfoIcon={false}
                 visibleButtonAddResponsiblePerson
                 visibleButtonPersonVisit
                 dataSource={listUsers}
                 loadingData={loadingUser}
                 filterDataGrid
                 selectionMode="single"
                 onSelectionChanged={onSelectUser}
    >
      <ColumnFixing enabled />
      {renderColumnDataGridUser}
      <Column cellRender={renderButtonEditUser}
              width={75}
              fixed
              fixedPosition="right"
      />
      <Template name="toolbarButtonAddResponsiblePerson" render={toolbarButtonAddUser} />
      <Template name="toolbarButtonVisitResponsiblePerson" render={toolbarButtonVisitUser} />
    </DataGridMVP>
  ), [
    renderColumnDataGridUser,
    listUsers,
    loadingUser,
    onSelectUser,
    toolbarButtonAddUser,
    toolbarButtonVisitUser,
    renderButtonEditUser,
    setThisDataGridInstance
  ]);

  const renderColumnDataGridRole = useMemo(
    () =>
      columnDataGridRole.map((item) => (
        <Column
          dataField={item.dataField}
          key={item.dataField}
          caption={item.caption}
          visible
          allowFiltering
          dataType={item.dataType}
          width={item.width}
        />
      )),
    []
  );
  const renderRoleList = useMemo(() => (
    <DataGridMVP className="shipment"
                 setStateStoringName="dataGridRoleList"
                 keyExpr="roleId"
                 setDataGridInstance={() => {}}
                 visibleButtonDateRangePicker={false}
                 visibleSummary={false}
                 visibleGroupPanel={false}
                 visibleInfoIcon={false}
                 visibleButtonAddResponsiblePerson
                 dataSource={listRolesOnUser}
                 loadingData={loadingRole}
                 filterDataGrid
                 selectionMode="single"
    >
      <ColumnFixing enabled />
      {renderColumnDataGridRole}
      <Column cellRender={renderButtonDelRole}
              width={75}
              fixed
              fixedPosition="right"
      />
      <Template name="toolbarButtonAddResponsiblePerson" render={toolbarButtonAddRole} />
    </DataGridMVP>
  ), [
    renderColumnDataGridRole,
    renderButtonDelRole,
    listRolesOnUser,
    loadingRole,
    toolbarButtonAddRole
  ]);
  const renderModalAddRole = useMemo(() => (
    <PopupMVP visible={visibleModalAddRole}
              onHiding={onHidingModalAddRole}
              title="Добавить роль"
    >
      <div className="formData">
        <div className="optionsData">
          <span>Список ролей</span>
          <SelectBox stylingMode="outlined"
                     items={listRoles}
                     displayExpr="roleName"
                     searchEnabled
                     value={selectRoleAddUser}
                     onValueChanged={({ value }) => setSelectRoleAddUser(value)}
          />
        </div>
        <div className="formButton">
          <Button text="Отмена"
                  type="default"
                  stylingMode="text"
                  onClick={onHidingModalAddRole}
          />
          <Button type="default"
                  stylingMode="contained"
                  onClick={sendSaveAddRole}
                  width={200}
                  disabled={!selectRoleAddUser}
          >
            <LoadIndicator className="indicator" visible={dataAddRole.loading} />
            <span>Сохранить</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    selectRoleAddUser,
    setSelectRoleAddUser,
    visibleModalAddRole,
    onHidingModalAddRole,
    sendSaveAddRole,
    dataAddRole.loading,
    listRoles
  ]);
  const renderModalDelRole = useMemo(() => (
    <PopupMVP visible={visibleModalDelRole}
              onHiding={onHidingModalDelRole}
              title="Удаление роли"
    >
      <div className="formData">
        <span>
          Удалить роль
          <b>{` "${selectRoleDelUser && selectRoleDelUser.roleName}" `}</b>
          у пользователя
          <b>{` "${selectedRowsDataUser.length && selectedRowsDataUser[0].name}" `}</b>
          ?
        </span>
        <div className="formButton">
          <Button text="Отмена"
                  type="default"
                  stylingMode="text"
                  onClick={onHidingModalDelRole}
          />
          <Button type="default"
                  stylingMode="contained"
                  onClick={sendSaveDelRole}
                  width={200}
          >
            <LoadIndicator className="indicator" visible={dataDelRole.loading} />
            <span>Удалить</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    visibleModalDelRole,
    onHidingModalDelRole,
    selectRoleDelUser,
    selectedRowsDataUser,
    sendSaveDelRole,
    dataDelRole.loading
  ]);
  const renderModalAddOrEditUser = useMemo(() => (
    <PopupMVP visible={visibleModalAddOrEditUser}
              onHiding={onHidingModalAddOrEditUser}
              title={dataUser.title}
    >
      <div className="formData">
        <div className="optionsRow">
          <div className="optionsData">
            <span>
              ФИО
              <sup>*</sup>
            </span>
            <TextBox stylingMode="outlined"
                     placeholder="Введите ФИО пользователя"
                     value={dataUser.name}
                     onValueChanged={({ value }) => {
                       setDataUser((item) => ({
                         ...item,
                         name: value
                       }));
                     }}
            >
              <Validator>
                <RequiredRule message="Обязательно для заполнения" />
                <StringLengthRule message="Обязательно для заполнения" min={2} />
                <PatternRule message="ФИО должно состоять из 3 слов"
                             pattern={/^[a-zA-Zа-яА-ЯёЁ0-9]*\s{1,}[a-zA-Zа-яА-ЯёЁ0-9]*\s{1,}[a-zA-Zа-яА-ЯёЁ0-9]*$/}
                />
              </Validator>
            </TextBox>
          </div>
        </div>
        <div className="optionsRow">
          <div className="optionsData">
            <span>
              Логин
              <sup>*</sup>
            </span>
            <TextBox stylingMode="outlined"
                     placeholder="Введите логин"
                     value={dataUser.userName}
                     onValueChanged={({ value }) => {
                       setDataUser((item) => ({
                         ...item,
                         userName: value
                       }));
                     }}
            >
              <Validator>
                <RequiredRule message="Обязательно для ввода" />
                <StringLengthRule message="Обязательно для заполнения" min={2} />
              </Validator>
            </TextBox>
          </div>
          <div className="optionsData">
            <span>Почта</span>
            <TextBox stylingMode="outlined"
                     placeholder="Введите email"
                     value={dataUser.emailAddress}
                     onValueChanged={({ value }) => {
                       setDataUser((item) => ({
                         ...item,
                         emailAddress: value
                       }));
                     }}
            >
              <Validator>
                <EmailRule message="Введите правильно Email" />
              </Validator>
            </TextBox>
          </div>
        </div>
        <div className="optionsRow">
          <div className="optionsData">
            <span>Телефон</span>
            { isForeignNumber
              ? (
                <TextBox stylingMode="outlined"
                         mode={'tel'}
                         placeholder="Введите телефон"
                         value={dataUser.phoneNumber}
                         valueChangeEvent="input"
                         onValueChanged={({ value }) => {
                           if (value.replace(/\D+/g, '').length <= 15) {
                             const digitsOnly = value.replace(/[^\d+()\-\s]/g, '');
                             setDataUser((item) => ({
                               ...item,
                               phoneNumber: digitsOnly
                             }));
                           }
                         }}
                />
              )
              : (
                <TextBox stylingMode="outlined"
                         mask={'+7 (000) 000-00-00'}
                         placeholder="Введите телефон"
                         value={dataUser.phoneNumber}
                         onValueChanged={({ value }) => {
                           setDataUser((item) => ({
                             ...item,
                             phoneNumber: value
                           }));
                         }}
                />
              )}
          </div>
          <div className="optionsData">
            <span>Номер заявки</span>
            <TextBox stylingMode="outlined"
                     placeholder="Введите номер заявки"
                     value={dataUser.requestId}
                     onValueChanged={({ value }) => {
                       setDataUser((item) => ({
                         ...item,
                         requestId: value
                       }));
                     }}
            />
          </div>
        </div>
        <div className="optionsRow">
          <div className="optionsData">
            <span style={{ marginRight: 10 }}>
              Иностранный номер
            </span>
            <CheckBox value={isForeignNumber}
                      onValueChanged={({ value }) => setIsForeignNumber(value)}
            />
          </div>
        </div>
        <div className="optionsRow">
          <div className="optionsData">
            <span style={{ marginRight: 10 }}>
              Внутренний сотрудник
            </span>
            <CheckBox value={dataUser.isVendorUser === 'Y'}
                      onValueChanged={({ value }) => {
                        setDataUser((item) => ({
                          ...item,
                          isVendorUser: item.isVendorUser === 'Y' ? 'N' : 'Y'
                        }));
                      }}
            />
          </div>
        </div>
        <div className="optionsRow">
          <div className="optionsData">
            <span style={{ marginRight: 10 }}>
              Деактивирован
              {' '}
            </span>
            <CheckBox value={dataUser.deletedFlag === 'Y'}
                      onValueChanged={({ value }) => {
                        setDataUser((item) => ({
                          ...item,
                          deletedFlag: item.deletedFlag === 'Y' ? 'N' : 'Y'
                        }));
                      }}
            />
          </div>
        </div>
        <div className="optionsRow">
          <div className="optionsData">
            <span>Примечание</span>
            <TextArea height={80}
                      stylingMode="outlined"
                      value={dataUser.notes}
                      onValueChanged={({ value }) => {
                        setDataUser((item) => ({
                          ...item,
                          notes: value
                        }));
                      }}
            />
          </div>
        </div>
        <div className="formButton">
          <Button text="Отмена"
                  type="default"
                  stylingMode="text"
                  onClick={onHidingModalAddOrEditUser}
          />
          <Button type="default"
                  stylingMode="contained"
                  onClick={sendSaveAddOrEditUser}
                  width={200}
          >
            <LoadIndicator className="indicator" visible={dataAddOrEditUser.loading} />
            <span>Сохранить</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    visibleModalAddOrEditUser,
    onHidingModalAddOrEditUser,
    dataUser,
    sendSaveAddOrEditUser,
    dataAddOrEditUser.loading,
    isForeignNumber
  ]);

  const renderColumnDataGrid = useMemo(
    () =>
      columnDataGrid.map((item) => (
        <Column
                dataField={item.dataField}
                caption={formatMessage('textVisit')[item.dataField]}
                visible={!item.notVisible}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )),
    []
  );

  const renderModalVisitUser = useMemo(() => (
    <PopupMVP visible={visibleModalVisitsUser}
            onHiding={onHidingModalVisitsUser}
            title={'Визиты пользователя'}
            width={1000}
            height={500}
    >
      <DataGridMVP
          dataSource={listVisits}
          filterDataGrid={filterVisitDataGrid}
          setFilterDataGrid={setFilterVisitDataGrid}
          selectionMode="none"
          keyExpr="fullName"
          tText={formatMessage('textPeriod')}
          dataGridOnOptionChanged={dataGridOnOptionChanged}
          setStateStoringName="dataGridGetListVisits"
          loadingData={loadingVisits}
          isDataLoading={loadingVisits}
          className="shipment"
          visibleInfoIcon={false}
          visibleSummary={false}
      >
        {renderColumnDataGrid}
      </DataGridMVP>
    </PopupMVP>
  ), [
    dataGridOnOptionChanged,
    filterVisitDataGrid,
    listVisits, loadingVisits,
    onHidingModalVisitsUser,
    renderColumnDataGrid,
    visibleModalVisitsUser
  ]);

  return (
    <div className={style.containing}>
      <SplitterLayout>
        <div>
          <p><b>Список пользователей</b></p>
          {renderUserList}
        </div>
        <div>
          <p>
            <b>Роли пользователя</b>
            {`${selectedRowsDataUser.length ? `: ${selectedRowsDataUser[0].name} (${selectedRowsDataUser[0].userName})` : ''}` }
          </p>
          {renderRoleList}
        </div>
      </SplitterLayout>
      {renderModalAddRole}
      {renderModalDelRole}
      {renderModalAddOrEditUser}
      {renderModalVisitUser}
    </div>
  );
};

export default UserAdmin;
